export default "__VITE_ASSET__d98b3e81__"